module.exports = __webpack_public_path__ + "media/images/zoom-aa6e0a6f07b51fab3215c4e9344f8c67.jpg";